module.exports = __webpack_public_path__ + "img/daniela.156d5380.jpg";